export const ORG_ID_HEADER = "X-Organization-ID";

const SELECTED_ORG_STORAGE_KEY = "selectedOrganization";

export function getOrgIdForRequest(): string | null {
  try {
    const raw = sessionStorage.getItem(SELECTED_ORG_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as { id?: string };
    return parsed?.id ?? null;
  } catch {
    return null;
  }
}

export function buildAuthHeaders(accessToken?: string | null): Record<string, string> {
  const headers: Record<string, string> = {};
  const token = accessToken ?? sessionStorage.getItem("access_token");
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const orgId = getOrgIdForRequest();
  if (orgId) {
    headers[ORG_ID_HEADER] = orgId;
  }
  return headers;
}

/** Verification routes are cross-org — do not send X-Organization-ID. */
export function buildVerificationHeaders(accessToken?: string | null): Record<string, string> {
  const headers: Record<string, string> = {};
  const token = accessToken ?? sessionStorage.getItem("access_token");
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}
